import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { SidebarService } from '../../servicies/sidebar.service';

@Component({
  selector: 'app-dynamic-sidebar',
  template: `
    <p-sidebar  [(visible)]="visible"  [modal]="true"  [showCloseIcon]="true"  position="right"  appendTo="body"  (onHide)="close()">
        <div class="sidebar-content" (click)="$event.stopPropagation()">
          <ng-container #sidebarContent></ng-container>
        </div>
    </p-sidebar>
  `,
  standalone: false
})
export class DynamicSidebarComponent implements OnInit {
  @ViewChild('sidebarContent', { read: ViewContainerRef, static: true }) container!: ViewContainerRef;
  visible = false;

  constructor(private sidebarService: SidebarService) { }

  ngOnInit() {
    this.sidebarService.setViewContainerRef(this.container);
    this.sidebarService.isSidebarVisible().subscribe((isVisible) => {
      this.visible = isVisible;
    });
  }

  close() {
    this.sidebarService.close();
  }


}
